module.exports = __webpack_public_path__ + "img/circle.80351379.png";